
import { parsingErrorResponse } from "@/app/infrastructures/misc/Utils";
import { ChipsStyles } from "@/app/ui/components/chips-v2/modules";
import { ListPickupController } from "@/app/ui/controllers/ListPickupController";
import { ApiStateData } from "@/domain/entities/Api";
import { PaginationV2 } from "@/domain/entities/Pagination";
import {
  ListPickup,
  RequestListPickupList,
  ListPickupList
} from "@/domain/entities/ListPickup";
import { Options, Vue } from "vue-class-component";
import ellipsisString from "@/app/infrastructures/misc/common-library/EllipsisString";
import router from "@/app/ui/router";
import ListPickupFilterBar from "@/app/ui/views/pickup/list-pickup/list/components/list-pickup-filter-bar.vue";
import formatDate from '@/app/infrastructures/misc/common-library/v2/FormatDate';

const PickupTypeTitle: { [x: string]: string } = {
  scheduled: "Pick Up terjadwal",
  instant: "Pick Up langsung"
};

@Options({
  components: {
    ListPickupFilterBar
  }
})
class PickupList extends Vue {
  isFirstLanding = true;

  mounted() {
    this.getListPickupList();
  }

  apiListData = new ApiStateData();
  listData: ListPickupList = new ListPickupList();

  async getListPickupList() {
    this.apiListData.loading = true;
    try {
      const resp = await ListPickupController.getListPickupList(
        new RequestListPickupList({
          page: this.listData.pagination.page,
          pickupSchedule: this.filter.lsPickupSchedule,
          transportType: this.filter.lsTransportTypeId,
          serviceCode: this.filter.lsServiceCodes,
          lastStatus: this.filter.lsLastStatus,
          shipmentId: this.filter.lsShipmentId,
          sortBy: this.filter.sortBy,
          isTotalData: true
        })
      );
      this.listData = new ListPickupList({
        pagination: new PaginationV2({
          page: resp.pagination.page,
          limit: resp.pagination.limit,
          totalData: resp.pagination.totalData
        }),
        data: resp.data
      });
      this.apiListData.errorType = "";
    } catch (error) {
      this.apiListData.errorType = parsingErrorResponse(error).type;
    } finally {
      this.apiListData.loading = false;
    }
  }

  get getTitle() {
    return this.$route.meta.title;
  }

  onClickRow(item: ListPickup) {
    router.push(`/pickup/list-pickup/${item.listPickupShipmentId}`);
  }

  filter = {
    lsShipmentId: "" as any,
    lsPickupSchedule: "" as any,
    lsTransportTypeId: "" as any,
    lsServiceCodes: "" as any,
    lsLastStatus: "" as any,
    sortBy: "" as any
  };

  get columns() {
    return [
      {
        name: this.$t("pickupCorporate.columnNo"),
        styleHead: "w-12 text-left",
        render: (_: any, index: any) => {
          return `<div class="text-left">${index +
            1 +
            this.listData.pagination.limit *
              (this.listData.pagination.page - 1)}</div>`;
        }
      },
      {
        name: "Shipment ID",
        styleHead: "w-56 text-left",
        render: (item: ListPickup) => {
          return `<div class="text-left">${item.listPickupShipmentId}</div>`;
        }
      },
      {
        name: "Referensi klien",
        styleHead: "w-44 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          return `<div class="text-left">${item.listPickupClientRef}</div>`;
        }
      },
      {
        name: "Jadwal Pick Up",
        styleHead: "w-48 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          return `<div class="overflow-ellipsis text-left">${item.formatPickupSchedule ||
            "-"}</div>`;
        }
      },
      {
        name: "Tipe armada",
        styleHead: "w-44 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          return `<div class="overflow-ellipsis text-left">${item.listPickupTransportType ||
            "-"}</div>`;
        }
      },
      {
        name: "Estimasi jumlah koli",
        styleHead: "w-48 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          return `<div class="flex flex-row">
          <p class="overflow-ellipsis text-left">${
            item.listPickupEstTotalKoli
          }</p> ${
            item.listPickupActualTotalKoli > 0
              ? ' <p class="overflow-ellipsis text-left text-gray-lp-600">&nbsp;(Aktual ' +
                item.listPickupActualTotalKoli +
                " Koli)</p>"
              : ""
          }
          </div>`;
        }
      },
      {
        name: "Tipe Pick Up",
        styleHead: "w-72 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          return `<div class="overflow-ellipsis text-left">${
            PickupTypeTitle[item.listPickupPickupType.toLowerCase()]
          }</div>`;
        }
      },
      {
        name: "Jenis pengiriman",
        styleHead: "w-80 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          const listPickupService = item.listPickupServiceCodes.replace(
            /,/g,
            ", "
          );
          return `<div class="flex flex-row">
            <p class="overflow-ellipsis text-left">${this.ellipsisString(
              listPickupService,
              item.isEllipsis
            )}</p>
            ${
              item.isEllipsis && listPickupService.length > 20
                ? '<p class="text-red-lp-100 text-decoration-line: underline">(Lihat semua)</p>'
                : ""
            }
          </div>`;
        },
        onClickValue: (item: ListPickup, index: number) => {
          this.listData.data[index].isEllipsis = !this.listData.data[index]
            .isEllipsis;
        }
      },
      {
        name: this.$t("pickupCorporate.columnShipmentId"),
        styleHead: "w-56 text-left",
        render: (item: ListPickup) => {
          return `<div class="text-left">${item.listPickupShipmentId}</div>`;
        }
      },
      {
        name: this.$t("pickupCorporate.columnClientRef"),
        styleHead: "w-44 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          return `<div class="text-left">${item.listPickupClientRef}</div>`;
        }
      },
      {
        name: this.$t("pickupCorporate.columnSchedule"),
        styleHead: "w-48 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          const formatted =
            item.listPickupPickupSchedule &&
            formatDate(
              item.listPickupPickupSchedule,
              "DD MMMM YYYY HH:mm",
              true,
              undefined,
              true
            );
          return `<div class="overflow-ellipsis text-left">${formatted ||
            "-"}</div>`;
        }
      },
      {
        name: this.$t("pickupCorporate.columnVehicleType"),
        styleHead: "w-44 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          return `<div class="overflow-ellipsis text-left">${item.listPickupTransportType ||
            "-"}</div>`;
        }
      },
      {
        name: this.$t("pickupCorporate.columnEstKoli"),
        styleHead: "w-48 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          const actual =
            item.listPickupActualTotalKoli > 0
              ? ` <p class="overflow-ellipsis text-left text-gray-lp-600">&nbsp;(${this.$t(
                  "pickupCorporate.actualKoli"
                )} ${item.listPickupActualTotalKoli} ${this.$t(
                  "pickupCorporate.koli"
                )})</p>`
              : "";
          return `<div class="flex flex-row">
          <p class="overflow-ellipsis text-left">${item.listPickupEstTotalKoli}</p>${actual}
          </div>`;
        }
      },
      {
        name: this.$t("pickupCorporate.columnPickupType"),
        styleHead: "w-72 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          const key =
            item.listPickupPickupType.toLowerCase() === "scheduled"
              ? "pickupCorporate.typeScheduled"
              : "pickupCorporate.typeInstant";
          return `<div class="overflow-ellipsis text-left">${this.$t(
            key
          )}</div>`;
        }
      },
      {
        name: this.$t("pickupCorporate.columnServiceType"),
        styleHead: "w-80 text-left whitespace-nowrap",
        render: (item: ListPickup) => {
          const listPickupService = item.listPickupServiceCodes.replace(
            /,/g,
            ", "
          );
          const seeAll =
            item.isEllipsis && listPickupService.length > 20
              ? `<p class="text-red-lp-100 text-decoration-line: underline">${this.$t(
                  "pickupCorporate.seeAll"
                )}</p>`
              : "";
          return `<div class="flex flex-row">
            <p class="overflow-ellipsis text-left">${this.ellipsisString(
              listPickupService,
              item.isEllipsis
            )}</p>${seeAll}
          </div>`;
        },
        onClickValue: (item: ListPickup, index: number) => {
          this.listData.data[index].isEllipsis = !this.listData.data[index]
            .isEllipsis;
        }
      },
      {
        name: this.$t("pickupCorporate.columnStatus"),
        styleHead: "w-48 text-left",
        render: (item: ListPickup) =>
          ChipsStyles({ status: item.listPickupLatestStatus })
      }
    ];
  }

  get isEmpty(): boolean {
    return (
      !this.listData.data.length && this.sumFilter === 0 && this.isFirstLanding
    );
    // add no filter
  }

  async onResetAdvancedFilter() {
    this.apiListData.loading = true;
    this.listData.pagination.page = 1;
    await this.getListPickupList();
  }

  get sumFilter(): number {
    return (
      (this.filter.lsTransportTypeId ? 1 : 0) +
      (this.filter.lsServiceCodes?.length ? 1 : 0) +
      (this.filter.lsLastStatus.length ? 1 : 0)
    );
  }

  ellipsisString(val: string, isElipsize: boolean) {
    return isElipsize && val.length > 20 ? ellipsisString(val, 20) : val;
  }

  onChangeAdvancedFilter() {
    this.listData.pagination.page = 1;
    this.getListPickupList();
    this.isFirstLanding = false;
  }
}

export default PickupList;
